module.exports = __webpack_public_path__ + "img/marketing_sharing.c5b76abb.svg";